exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1240px){.box-flex-avm{padding:0 20px}}.flex-module{max-width:1240px;margin:0 auto 60px;display:flex;gap:50px;justify-content:center;align-items:center;border-radius:20px}@media (max-width:768px){.flex-module{display:flex;flex-direction:column;gap:30px;margin:0 auto 40px}}.flex-avm-btn{width:220px!important;height:54px!important;font-size:16px!important;margin-top:20px}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};